module.exports = __webpack_public_path__ + "static/img/game7.ad531880.png";